import { Planet20Regular, Info20Regular, Beaker16Regular } from '@fluentui/react-icons';
import { createModuleConfig } from '../createModuleConfig';
import { lazyPage } from '../lazyPage';

const TestCasesOverviewPage = lazyPage(() => import('./tools/overview/pages/OverviewPage'));
const RegressionTestsPage = lazyPage(() => import('./tools/regression/pages/RegressionTestsPage'));

const testCasesModuleConfig = createModuleConfig({
  key: 'test-cases',
  name: 'Test Cases',
  domain: { title: 'Test Cases', icon: Beaker16Regular },
  tools: [
    { 
      key: 'overview',
      name: 'Overview',
      title: 'Test Cases Overview',
      path: '/test-cases', 
      element: <TestCasesOverviewPage />, 
      nav: { name: 'Overview', icon: Planet20Regular }
    },
    { 
      key: 'regression',
      name: 'Regression Tests',
      title: 'Regression Tests',
      path: '/test-cases/regression', 
      element: <RegressionTestsPage />, 
      nav: { name: 'Regression Tests', icon: Info20Regular }
    },
  ],
});

export default testCasesModuleConfig;
